//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import moment from 'moment';
import 'moment-duration-format';

export class AdminApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    rebuildAll(signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/admin/rebuild";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRebuildAll(_response);
        });
    }

    protected processRebuildAll(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    pruneDocuments(signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/admin/documents/prune";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPruneDocuments(_response);
        });
    }

    protected processPruneDocuments(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ArtifactsApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    put(id: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/trends/{id}/artifact";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(id: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/trends/{id}/artifact";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    search(userId: string | null | undefined, query: string | null | undefined, signal?: AbortSignal): Promise<ArtifactsSearchResultsDto> {
        let url_ = this.baseUrl + "/api/trends/artifacts/search?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (query !== undefined && query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<ArtifactsSearchResultsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArtifactsSearchResultsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArtifactsSearchResultsDto>(null as any);
    }

    getLastSaved(id: string, signal?: AbortSignal): Promise<moment.Moment | null> {
        let url_ = this.baseUrl + "/api/trends/{id}/artifact/lastsaved";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLastSaved(_response);
        });
    }

    protected processGetLastSaved(response: Response): Promise<moment.Moment | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? moment(resultData200.toString()) : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<moment.Moment | null>(null as any);
    }
}

export class BlobApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getFolders(date: string | null | undefined, prefix: string | null | undefined, signal?: AbortSignal): Promise<BlobPath[]> {
        let url_ = this.baseUrl + "/api/blobs/folders?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (prefix !== undefined && prefix !== null)
            url_ += "prefix=" + encodeURIComponent("" + prefix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFolders(_response);
        });
    }

    protected processGetFolders(response: Response): Promise<BlobPath[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BlobPath.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BlobPath[]>(null as any);
    }

    getAll(date: string | null | undefined, pageSize: number | undefined, signal?: AbortSignal): Promise<BlobGroupDto[]> {
        let url_ = this.baseUrl + "/api/blobs?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<BlobGroupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BlobGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BlobGroupDto[]>(null as any);
    }

    deleteMultiple(blobGroupPaths: string[], signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/blobs/delete-multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(blobGroupPaths);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteMultiple(_response);
        });
    }

    protected processDeleteMultiple(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class DataFeedsApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(id: string, format: string, limit: number | undefined, dateOffset: CsvDateOffset | undefined, dateFormat: CsvDateFormat | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/trends/{id}/files/{format}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (dateOffset === null)
            throw new Error("The parameter 'dateOffset' cannot be null.");
        else if (dateOffset !== undefined)
            url_ += "dateOffset=" + encodeURIComponent("" + dateOffset) + "&";
        if (dateFormat === null)
            throw new Error("The parameter 'dateFormat' cannot be null.");
        else if (dateFormat !== undefined)
            url_ += "dateFormat=" + encodeURIComponent("" + dateFormat) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAuthenticated(id: string, format: string, limit: number | undefined, dateOffset: CsvDateOffset | undefined, dateFormat: CsvDateFormat | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/trends/{id}/data/{format}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (dateOffset === null)
            throw new Error("The parameter 'dateOffset' cannot be null.");
        else if (dateOffset !== undefined)
            url_ += "dateOffset=" + encodeURIComponent("" + dateOffset) + "&";
        if (dateFormat === null)
            throw new Error("The parameter 'dateFormat' cannot be null.");
        else if (dateFormat !== undefined)
            url_ += "dateFormat=" + encodeURIComponent("" + dateFormat) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAuthenticated(_response);
        });
    }

    protected processGetAuthenticated(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class EntryPointArgsApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    home(signal?: AbortSignal): Promise<HomeEntryPointArgs> {
        let url_ = this.baseUrl + "/api/entrypointargs/home";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHome(_response);
        });
    }

    protected processHome(response: Response): Promise<HomeEntryPointArgs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HomeEntryPointArgs.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HomeEntryPointArgs>(null as any);
    }

    trend(id: string | null | undefined, signal?: AbortSignal): Promise<TrendEntryPointArgs> {
        let url_ = this.baseUrl + "/api/entrypointargs/trend?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTrend(_response);
        });
    }

    protected processTrend(response: Response): Promise<TrendEntryPointArgs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrendEntryPointArgs.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrendEntryPointArgs>(null as any);
    }

    artifacts(id: string | null | undefined, signal?: AbortSignal): Promise<ArtifactEntryPointArgs> {
        let url_ = this.baseUrl + "/api/entrypointargs/artifacts?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processArtifacts(_response);
        });
    }

    protected processArtifacts(response: Response): Promise<ArtifactEntryPointArgs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArtifactEntryPointArgs.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArtifactEntryPointArgs>(null as any);
    }

    embeddables(id: string | null | undefined, signal?: AbortSignal): Promise<EmbeddableArtifactEntryPointArgs> {
        let url_ = this.baseUrl + "/api/entrypointargs/embeddables?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmbeddables(_response);
        });
    }

    protected processEmbeddables(response: Response): Promise<EmbeddableArtifactEntryPointArgs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmbeddableArtifactEntryPointArgs.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmbeddableArtifactEntryPointArgs>(null as any);
    }
}

export class FeatureTogglesApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    toggleForMe(featureToggle: FeatureToggle | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/featuretoggles/me?";
        if (featureToggle === null)
            throw new Error("The parameter 'featureToggle' cannot be null.");
        else if (featureToggle !== undefined)
            url_ += "featureToggle=" + encodeURIComponent("" + featureToggle) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToggleForMe(_response);
        });
    }

    protected processToggleForMe(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    toggleForEveryone(featureToggle: FeatureToggle | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/featuretoggles/everyone?";
        if (featureToggle === null)
            throw new Error("The parameter 'featureToggle' cannot be null.");
        else if (featureToggle !== undefined)
            url_ += "featureToggle=" + encodeURIComponent("" + featureToggle) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToggleForEveryone(_response);
        });
    }

    protected processToggleForEveryone(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    turnOnForPeople(featureToggle: FeatureToggle, people: string[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/featuretoggles/forpeople/{featureToggle}";
        if (featureToggle === undefined || featureToggle === null)
            throw new Error("The parameter 'featureToggle' must be defined.");
        url_ = url_.replace("{featureToggle}", encodeURIComponent("" + featureToggle));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(people);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTurnOnForPeople(_response);
        });
    }

    protected processTurnOnForPeople(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAllStatuses(signal?: AbortSignal): Promise<FeatureToggleSummary[]> {
        let url_ = this.baseUrl + "/api/featuretoggles/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllStatuses(_response);
        });
    }

    protected processGetAllStatuses(response: Response): Promise<FeatureToggleSummary[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeatureToggleSummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeatureToggleSummary[]>(null as any);
    }

    get(signal?: AbortSignal): Promise<{ [key in keyof typeof FeatureToggle]?: boolean; }> {
        let url_ = this.baseUrl + "/api/featuretoggles/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<{ [key in keyof typeof FeatureToggle]?: boolean; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key in keyof typeof FeatureToggle]?: boolean; }>(null as any);
    }
}

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/featuretoggles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class InputDataDefinitionsApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    search(search: string | null | undefined, facets: string | null | undefined, tabId: string | null | undefined, groups: string | null | undefined, signal?: AbortSignal): Promise<SearchResultDto> {
        let url_ = this.baseUrl + "/api/inputdatadefinitions/search?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (facets !== undefined && facets !== null)
            url_ += "Facets=" + encodeURIComponent("" + facets) + "&";
        if (tabId !== undefined && tabId !== null)
            url_ += "TabId=" + encodeURIComponent("" + tabId) + "&";
        if (groups !== undefined && groups !== null)
            url_ += "Groups=" + encodeURIComponent("" + groups) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<SearchResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchResultDto>(null as any);
    }

    get(ids: IMetricDto[], signal?: AbortSignal): Promise<InputDataDefinitionDto[]> {
        let url_ = this.baseUrl + "/api/inputdatadefinitions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<InputDataDefinitionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InputDataDefinitionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InputDataDefinitionDto[]>(null as any);
    }

    getChildren(requestDto: MetricChildrenRequestDto, signal?: AbortSignal): Promise<InputDataDefinitionDto[]> {
        let url_ = this.baseUrl + "/api/inputdatadefinitions/getchildren";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetChildren(_response);
        });
    }

    protected processGetChildren(response: Response): Promise<InputDataDefinitionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InputDataDefinitionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InputDataDefinitionDto[]>(null as any);
    }
}

export class OrganisationsApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(signal?: AbortSignal): Promise<Organisation[]> {
        let url_ = this.baseUrl + "/api/organisations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Organisation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Organisation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Organisation[]>(null as any);
    }
}

export class TemplatesApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    post(includeOnHomePage: boolean | undefined, trend: TrendDto, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/templates?";
        if (includeOnHomePage === null)
            throw new Error("The parameter 'includeOnHomePage' cannot be null.");
        else if (includeOnHomePage !== undefined)
            url_ += "includeOnHomePage=" + encodeURIComponent("" + includeOnHomePage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trend);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAll(signal?: AbortSignal): Promise<TemplateSummaryDto[]> {
        let url_ = this.baseUrl + "/api/templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<TemplateSummaryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateSummaryDto[]>(null as any);
    }

    delete(id: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/templates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createTrend(id: string, signal?: AbortSignal): Promise<TrendResourceDto> {
        let url_ = this.baseUrl + "/api/templates/trends/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTrend(_response);
        });
    }

    protected processCreateTrend(response: Response): Promise<TrendResourceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrendResourceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrendResourceDto>(null as any);
    }
}

export class TrendsApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(signal?: AbortSignal): Promise<TrendSummaryResourceDto[]> {
        let url_ = this.baseUrl + "/api/trends";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<TrendSummaryResourceDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrendSummaryResourceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrendSummaryResourceDto[]>(null as any);
    }

    description(id: string, signal?: AbortSignal): Promise<TrendDescriptionDto> {
        let url_ = this.baseUrl + "/api/trends/{id}/description";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDescription(_response);
        });
    }

    protected processDescription(response: Response): Promise<TrendDescriptionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrendDescriptionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrendDescriptionDto>(null as any);
    }

    get(id: string, signal?: AbortSignal): Promise<TrendResourceDto> {
        let url_ = this.baseUrl + "/api/trends/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<TrendResourceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrendResourceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrendResourceDto>(null as any);
    }

    put(id: string, trend: TrendDto, signal?: AbortSignal): Promise<TrendPutResult> {
        let url_ = this.baseUrl + "/api/trends/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trend);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<TrendPutResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrendPutResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrendPutResult>(null as any);
    }

    delete(id: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/trends/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    copy(trendId: string, userId: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/trends/{trendId}/copy/{userId}";
        if (trendId === undefined || trendId === null)
            throw new Error("The parameter 'trendId' must be defined.");
        url_ = url_.replace("{trendId}", encodeURIComponent("" + trendId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCopy(_response);
        });
    }

    protected processCopy(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    claim(id: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/trends/{id}/claim";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClaim(_response);
        });
    }

    protected processClaim(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    publish(id: string, publishingDetails: TrendPublishDto, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/trends/{id}/publish";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(publishingDetails);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublish(_response);
        });
    }

    protected processPublish(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ClientAuthenticationApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getJavaScriptClient(signal?: AbortSignal): Promise<JavaScriptClientDto> {
        let url_ = this.baseUrl + "/api/authentication/javascript-client";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJavaScriptClient(_response);
        });
    }

    protected processGetJavaScriptClient(response: Response): Promise<JavaScriptClientDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JavaScriptClientDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JavaScriptClientDto>(null as any);
    }
}

export class ClientAuthorisationApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    isAuthorised(policies: string[] | null | undefined, signal?: AbortSignal): Promise<IsAuthorisedDto> {
        let url_ = this.baseUrl + "/api/authorisation/is-authorised?";
        if (policies !== undefined && policies !== null)
            policies && policies.forEach(item => { url_ += "policies=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsAuthorised(_response);
        });
    }

    protected processIsAuthorised(response: Response): Promise<IsAuthorisedDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsAuthorisedDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IsAuthorisedDto>(null as any);
    }
}

export class TrendsMetricsApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    trendsQuery(purpose: string | null | undefined, request: SeriesDataCollectionRequestDto, signal?: AbortSignal): Promise<TrendsMetricApiResponse[]> {
        let url_ = this.baseUrl + "/api/metrics?";
        if (purpose !== undefined && purpose !== null)
            url_ += "purpose=" + encodeURIComponent("" + purpose) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTrendsQuery(_response);
        });
    }

    protected processTrendsQuery(response: Response): Promise<TrendsMetricApiResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrendsMetricApiResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrendsMetricApiResponse[]>(null as any);
    }

    status(url: string | null | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/metrics/status?";
        if (url !== undefined && url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStatus(_response);
        });
    }

    protected processStatus(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    read(url: string | null | undefined, signal?: AbortSignal): Promise<DataPointDto[]> {
        let url_ = this.baseUrl + "/api/metrics/read?";
        if (url !== undefined && url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRead(_response);
        });
    }

    protected processRead(response: Response): Promise<DataPointDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataPointDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataPointDto[]>(null as any);
    }
}

export class ArtifactsSearchResultsDto implements IArtifactsSearchResultsDto {
    trends!: ArtifactsSearchResultDto[] | undefined;

    constructor(data?: IArtifactsSearchResultsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["trends"])) {
                this.trends = [] as any;
                for (let item of _data["trends"])
                    this.trends!.push(ArtifactsSearchResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArtifactsSearchResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArtifactsSearchResultsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.trends)) {
            data["trends"] = [];
            for (let item of this.trends)
                data["trends"].push(item.toJSON());
        }
        return data;
    }
}

export interface IArtifactsSearchResultsDto {
    trends: ArtifactsSearchResultDto[] | undefined;
}

export class ArtifactsSearchResultDto implements IArtifactsSearchResultDto {
    score!: number;
    publishedUri!: string | undefined;
    id!: string | undefined;
    title!: string | undefined;
    description!: string | undefined;
    outputType!: string | undefined;
    owner!: string | undefined;

    constructor(data?: IArtifactsSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["score"];
            this.publishedUri = _data["publishedUri"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.outputType = _data["outputType"];
            this.owner = _data["owner"];
        }
    }

    static fromJS(data: any): ArtifactsSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArtifactsSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score;
        data["publishedUri"] = this.publishedUri;
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["outputType"] = this.outputType;
        data["owner"] = this.owner;
        return data;
    }
}

export interface IArtifactsSearchResultDto {
    score: number;
    publishedUri: string | undefined;
    id: string | undefined;
    title: string | undefined;
    description: string | undefined;
    outputType: string | undefined;
    owner: string | undefined;
}

export class BlobPath implements IBlobPath {
    name!: string | undefined;
    canDelete!: boolean;

    constructor(data?: IBlobPath) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.canDelete = _data["canDelete"];
        }
    }

    static fromJS(data: any): BlobPath {
        data = typeof data === 'object' ? data : {};
        let result = new BlobPath();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["canDelete"] = this.canDelete;
        return data;
    }
}

export interface IBlobPath {
    name: string | undefined;
    canDelete: boolean;
}

export class BlobGroupDto implements IBlobGroupDto {
    path!: string | undefined;
    name!: string | undefined;

    constructor(data?: IBlobGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BlobGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlobGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        data["name"] = this.name;
        return data;
    }
}

export interface IBlobGroupDto {
    path: string | undefined;
    name: string | undefined;
}

export enum CsvDateOffset {
    Nem = 0,
    Utc = 1,
}

export enum CsvDateFormat {
    Excel = 0,
    Iso8601 = 1,
}

export class HomeEntryPointArgs implements IHomeEntryPointArgs {
    accountStatus!: AccountStatusDto;
    product!: ProductDto;
    policyAuthorisations!: PolicyAuthorisationDto[];
    feedbackBaseUrl!: string;
    apiVersion!: string;
    showAppBar!: boolean;

    constructor(data?: IHomeEntryPointArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.accountStatus = new AccountStatusDto();
            this.product = new ProductDto();
            this.policyAuthorisations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountStatus = _data["accountStatus"] ? AccountStatusDto.fromJS(_data["accountStatus"]) : new AccountStatusDto();
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : new ProductDto();
            if (Array.isArray(_data["policyAuthorisations"])) {
                this.policyAuthorisations = [] as any;
                for (let item of _data["policyAuthorisations"])
                    this.policyAuthorisations!.push(PolicyAuthorisationDto.fromJS(item));
            }
            this.feedbackBaseUrl = _data["feedbackBaseUrl"];
            this.apiVersion = _data["apiVersion"];
            this.showAppBar = _data["showAppBar"];
        }
    }

    static fromJS(data: any): HomeEntryPointArgs {
        data = typeof data === 'object' ? data : {};
        let result = new HomeEntryPointArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountStatus"] = this.accountStatus ? this.accountStatus.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        if (Array.isArray(this.policyAuthorisations)) {
            data["policyAuthorisations"] = [];
            for (let item of this.policyAuthorisations)
                data["policyAuthorisations"].push(item.toJSON());
        }
        data["feedbackBaseUrl"] = this.feedbackBaseUrl;
        data["apiVersion"] = this.apiVersion;
        data["showAppBar"] = this.showAppBar;
        return data;
    }
}

export interface IHomeEntryPointArgs {
    accountStatus: AccountStatusDto;
    product: ProductDto;
    policyAuthorisations: PolicyAuthorisationDto[];
    feedbackBaseUrl: string;
    apiVersion: string;
    showAppBar: boolean;
}

export class AccountStatusDto implements IAccountStatusDto {
    name!: string | undefined;
    email!: string | undefined;
    imageUrl!: string | undefined;

    constructor(data?: IAccountStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): AccountStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["imageUrl"] = this.imageUrl;
        return data;
    }
}

export interface IAccountStatusDto {
    name: string | undefined;
    email: string | undefined;
    imageUrl: string | undefined;
}

export class ProductDto implements IProductDto {
    id!: string | undefined;
    name!: string | undefined;
    prereleaseTag!: string | undefined;

    constructor(data?: IProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.prereleaseTag = _data["prereleaseTag"];
        }
    }

    static fromJS(data: any): ProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["prereleaseTag"] = this.prereleaseTag;
        return data;
    }
}

export interface IProductDto {
    id: string | undefined;
    name: string | undefined;
    prereleaseTag: string | undefined;
}

export class PolicyAuthorisationDto implements IPolicyAuthorisationDto {
    name!: string | undefined;
    isAuthorised!: boolean;

    constructor(data?: IPolicyAuthorisationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isAuthorised = _data["isAuthorised"];
        }
    }

    static fromJS(data: any): PolicyAuthorisationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyAuthorisationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isAuthorised"] = this.isAuthorised;
        return data;
    }
}

export interface IPolicyAuthorisationDto {
    name: string | undefined;
    isAuthorised: boolean;
}

export class TrendEntryPointArgs implements ITrendEntryPointArgs {
    product!: ProductDto | undefined;
    accountStatus!: AccountStatusDto | undefined;
    apiVersion!: string | undefined;
    policyAuthorisations!: PolicyAuthorisationDto[] | undefined;
    feedbackBaseUrl!: string | undefined;
    trendResource!: TrendResourceDto | undefined;
    showAppBar!: boolean;

    constructor(data?: ITrendEntryPointArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            this.accountStatus = _data["accountStatus"] ? AccountStatusDto.fromJS(_data["accountStatus"]) : <any>undefined;
            this.apiVersion = _data["apiVersion"];
            if (Array.isArray(_data["policyAuthorisations"])) {
                this.policyAuthorisations = [] as any;
                for (let item of _data["policyAuthorisations"])
                    this.policyAuthorisations!.push(PolicyAuthorisationDto.fromJS(item));
            }
            this.feedbackBaseUrl = _data["feedbackBaseUrl"];
            this.trendResource = _data["trendResource"] ? TrendResourceDto.fromJS(_data["trendResource"]) : <any>undefined;
            this.showAppBar = _data["showAppBar"];
        }
    }

    static fromJS(data: any): TrendEntryPointArgs {
        data = typeof data === 'object' ? data : {};
        let result = new TrendEntryPointArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["accountStatus"] = this.accountStatus ? this.accountStatus.toJSON() : <any>undefined;
        data["apiVersion"] = this.apiVersion;
        if (Array.isArray(this.policyAuthorisations)) {
            data["policyAuthorisations"] = [];
            for (let item of this.policyAuthorisations)
                data["policyAuthorisations"].push(item.toJSON());
        }
        data["feedbackBaseUrl"] = this.feedbackBaseUrl;
        data["trendResource"] = this.trendResource ? this.trendResource.toJSON() : <any>undefined;
        data["showAppBar"] = this.showAppBar;
        return data;
    }
}

export interface ITrendEntryPointArgs {
    product: ProductDto | undefined;
    accountStatus: AccountStatusDto | undefined;
    apiVersion: string | undefined;
    policyAuthorisations: PolicyAuthorisationDto[] | undefined;
    feedbackBaseUrl: string | undefined;
    trendResource: TrendResourceDto | undefined;
    showAppBar: boolean;
}

export class TrendResourceDto implements ITrendResourceDto {
    trend!: TrendDto;
    links!: TrendLinksDto | undefined;
    apiLinks!: TrendApiLinksDto | undefined;

    constructor(data?: ITrendResourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.trend = new TrendDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trend = _data["trend"] ? TrendDto.fromJS(_data["trend"]) : new TrendDto();
            this.links = _data["links"] ? TrendLinksDto.fromJS(_data["links"]) : <any>undefined;
            this.apiLinks = _data["apiLinks"] ? TrendApiLinksDto.fromJS(_data["apiLinks"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TrendResourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrendResourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trend"] = this.trend ? this.trend.toJSON() : <any>undefined;
        data["links"] = this.links ? this.links.toJSON() : <any>undefined;
        data["apiLinks"] = this.apiLinks ? this.apiLinks.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITrendResourceDto {
    trend: TrendDto;
    links: TrendLinksDto | undefined;
    apiLinks: TrendApiLinksDto | undefined;
}

export class TrendDto implements ITrendDto {
    id!: string;
    version!: number;
    userId!: string | undefined;
    lastSavedTime!: moment.Moment;
    isDeleted!: boolean;
    deletionTime!: moment.Moment | undefined;
    _etag!: string | undefined;
    isDraft!: boolean;
    isPublished!: boolean;
    isPublishedToEveryone!: boolean;
    publishedToOrganisations!: string[] | undefined;
    creationTime!: moment.Moment;
    title!: string | undefined;
    isReadOnlyMode!: boolean;
    currentStepId!: TrendStep;
    dataDefinition!: TrendDataDefinitionDto | undefined;
    channels!: ChannelContainerDto[] | undefined;
    selectedChannelIndex!: number;

    constructor(data?: ITrendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.version = _data["version"];
            this.userId = _data["userId"];
            this.lastSavedTime = _data["lastSavedTime"] ? moment(_data["lastSavedTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this._etag = _data["_etag"];
            this.isDraft = _data["isDraft"];
            this.isPublished = _data["isPublished"];
            this.isPublishedToEveryone = _data["isPublishedToEveryone"];
            if (Array.isArray(_data["publishedToOrganisations"])) {
                this.publishedToOrganisations = [] as any;
                for (let item of _data["publishedToOrganisations"])
                    this.publishedToOrganisations!.push(item);
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.isReadOnlyMode = _data["isReadOnlyMode"];
            this.currentStepId = _data["currentStepId"];
            this.dataDefinition = _data["dataDefinition"] ? TrendDataDefinitionDto.fromJS(_data["dataDefinition"]) : <any>undefined;
            if (Array.isArray(_data["channels"])) {
                this.channels = [] as any;
                for (let item of _data["channels"])
                    this.channels!.push(ChannelContainerDto.fromJS(item));
            }
            this.selectedChannelIndex = _data["selectedChannelIndex"];
        }
    }

    static fromJS(data: any): TrendDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["version"] = this.version;
        data["userId"] = this.userId;
        data["lastSavedTime"] = this.lastSavedTime ? this.lastSavedTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["_etag"] = this._etag;
        data["isDraft"] = this.isDraft;
        data["isPublished"] = this.isPublished;
        data["isPublishedToEveryone"] = this.isPublishedToEveryone;
        if (Array.isArray(this.publishedToOrganisations)) {
            data["publishedToOrganisations"] = [];
            for (let item of this.publishedToOrganisations)
                data["publishedToOrganisations"].push(item);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["isReadOnlyMode"] = this.isReadOnlyMode;
        data["currentStepId"] = this.currentStepId;
        data["dataDefinition"] = this.dataDefinition ? this.dataDefinition.toJSON() : <any>undefined;
        if (Array.isArray(this.channels)) {
            data["channels"] = [];
            for (let item of this.channels)
                data["channels"].push(item.toJSON());
        }
        data["selectedChannelIndex"] = this.selectedChannelIndex;
        return data;
    }
}

export interface ITrendDto {
    id: string;
    version: number;
    userId: string | undefined;
    lastSavedTime: moment.Moment;
    isDeleted: boolean;
    deletionTime: moment.Moment | undefined;
    _etag: string | undefined;
    isDraft: boolean;
    isPublished: boolean;
    isPublishedToEveryone: boolean;
    publishedToOrganisations: string[] | undefined;
    creationTime: moment.Moment;
    title: string | undefined;
    isReadOnlyMode: boolean;
    currentStepId: TrendStep;
    dataDefinition: TrendDataDefinitionDto | undefined;
    channels: ChannelContainerDto[] | undefined;
    selectedChannelIndex: number;
}

export enum TrendStep {
    RawDataSelection = "RawDataSelection",
    ConfigureData = "ConfigureData",
    Viewer = "Viewer",
    Publish = "Publish",
}

export class TrendDataDefinitionDto implements ITrendDataDefinitionDto {
    appDateTimes!: AppDateTimesDto | undefined;
    configuredDataDefinitions!: ConfiguredMetricDto[] | undefined;

    constructor(data?: ITrendDataDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appDateTimes = _data["appDateTimes"] ? AppDateTimesDto.fromJS(_data["appDateTimes"]) : <any>undefined;
            if (Array.isArray(_data["configuredDataDefinitions"])) {
                this.configuredDataDefinitions = [] as any;
                for (let item of _data["configuredDataDefinitions"])
                    this.configuredDataDefinitions!.push(ConfiguredMetricDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrendDataDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrendDataDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appDateTimes"] = this.appDateTimes ? this.appDateTimes.toJSON() : <any>undefined;
        if (Array.isArray(this.configuredDataDefinitions)) {
            data["configuredDataDefinitions"] = [];
            for (let item of this.configuredDataDefinitions)
                data["configuredDataDefinitions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITrendDataDefinitionDto {
    appDateTimes: AppDateTimesDto | undefined;
    configuredDataDefinitions: ConfiguredMetricDto[] | undefined;
}

export class AppDateTimesDto implements IAppDateTimesDto {
    fixedStart!: moment.Moment | undefined;
    fixedEnd!: moment.Moment | undefined;
    lookBack!: RelativeDurationDto | undefined;
    lookForward!: RelativeDurationDto | undefined;
    isLive!: boolean;
    isRelative!: boolean;
    utcOffsetDefinition!: UtcOffsetDefinitionDto | undefined;

    constructor(data?: IAppDateTimesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedStart = _data["fixedStart"] ? moment(_data["fixedStart"].toString()) : <any>undefined;
            this.fixedEnd = _data["fixedEnd"] ? moment(_data["fixedEnd"].toString()) : <any>undefined;
            this.lookBack = _data["lookBack"] ? RelativeDurationDto.fromJS(_data["lookBack"]) : <any>undefined;
            this.lookForward = _data["lookForward"] ? RelativeDurationDto.fromJS(_data["lookForward"]) : <any>undefined;
            this.isLive = _data["isLive"];
            this.isRelative = _data["isRelative"];
            this.utcOffsetDefinition = _data["utcOffsetDefinition"] ? UtcOffsetDefinitionDto.fromJS(_data["utcOffsetDefinition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppDateTimesDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppDateTimesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedStart"] = this.fixedStart ? this.fixedStart.toISOString() : <any>undefined;
        data["fixedEnd"] = this.fixedEnd ? this.fixedEnd.toISOString() : <any>undefined;
        data["lookBack"] = this.lookBack ? this.lookBack.toJSON() : <any>undefined;
        data["lookForward"] = this.lookForward ? this.lookForward.toJSON() : <any>undefined;
        data["isLive"] = this.isLive;
        data["isRelative"] = this.isRelative;
        data["utcOffsetDefinition"] = this.utcOffsetDefinition ? this.utcOffsetDefinition.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAppDateTimesDto {
    fixedStart: moment.Moment | undefined;
    fixedEnd: moment.Moment | undefined;
    lookBack: RelativeDurationDto | undefined;
    lookForward: RelativeDurationDto | undefined;
    isLive: boolean;
    isRelative: boolean;
    utcOffsetDefinition: UtcOffsetDefinitionDto | undefined;
}

export class RelativeDurationDto implements IRelativeDurationDto {
    unitId!: RelativeDurationUnitId;
    count!: number;

    constructor(data?: IRelativeDurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitId = _data["unitId"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): RelativeDurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelativeDurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId;
        data["count"] = this.count;
        return data;
    }
}

export interface IRelativeDurationDto {
    unitId: RelativeDurationUnitId;
    count: number;
}

export enum RelativeDurationUnitId {
    Minute = "minute",
    Hour = "hour",
    Day = "day",
    Week = "week",
    Month = "month",
    Year = "year",
    CompleteWeek = "completeWeek",
    CompleteMonth = "completeMonth",
    CompleteQuarter = "completeQuarter",
    CompleteFinancialYear = "completeFinancialYear",
    CompleteCalendarYear = "completeCalendarYear",
}

export class UtcOffsetDefinitionDto implements IUtcOffsetDefinitionDto {
    fixedOffsetInMinutes!: number | undefined;
    timeZone!: string | undefined;

    constructor(data?: IUtcOffsetDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedOffsetInMinutes = _data["fixedOffsetInMinutes"];
            this.timeZone = _data["timeZone"];
        }
    }

    static fromJS(data: any): UtcOffsetDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UtcOffsetDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedOffsetInMinutes"] = this.fixedOffsetInMinutes;
        data["timeZone"] = this.timeZone;
        return data;
    }
}

export interface IUtcOffsetDefinitionDto {
    fixedOffsetInMinutes: number | undefined;
    timeZone: string | undefined;
}

export class ConfiguredMetricDto implements IConfiguredMetricDto {
    id!: string;
    calculationVariableName!: string;
    name!: string;
    unitsOfMeasure!: UnitsOfMeasureDto;
    dataSummary!: DataSummaryDto;
    inputDataDefinitionId!: IMetricDto;
    timeStep!: TimeStep;
    aggregate!: Aggregation;
    isIncludedInOutputChannels!: boolean;
    maxDataPoints!: number;

    constructor(data?: IConfiguredMetricDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.unitsOfMeasure = new UnitsOfMeasureDto();
            this.dataSummary = new DataSummaryDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.calculationVariableName = _data["calculationVariableName"];
            this.name = _data["name"];
            this.unitsOfMeasure = _data["unitsOfMeasure"] ? UnitsOfMeasureDto.fromJS(_data["unitsOfMeasure"]) : new UnitsOfMeasureDto();
            this.dataSummary = _data["dataSummary"] ? DataSummaryDto.fromJS(_data["dataSummary"]) : new DataSummaryDto();
            this.inputDataDefinitionId = _data["inputDataDefinitionId"] ? IMetricDto.fromJS(_data["inputDataDefinitionId"]) : <any>undefined;
            this.timeStep = _data["timeStep"];
            this.aggregate = _data["aggregate"];
            this.isIncludedInOutputChannels = _data["isIncludedInOutputChannels"];
            this.maxDataPoints = _data["maxDataPoints"];
        }
    }

    static fromJS(data: any): ConfiguredMetricDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfiguredMetricDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["calculationVariableName"] = this.calculationVariableName;
        data["name"] = this.name;
        data["unitsOfMeasure"] = this.unitsOfMeasure ? this.unitsOfMeasure.toJSON() : <any>undefined;
        data["dataSummary"] = this.dataSummary ? this.dataSummary.toJSON() : <any>undefined;
        data["inputDataDefinitionId"] = this.inputDataDefinitionId ? this.inputDataDefinitionId.toJSON() : <any>undefined;
        data["timeStep"] = this.timeStep;
        data["aggregate"] = this.aggregate;
        data["isIncludedInOutputChannels"] = this.isIncludedInOutputChannels;
        data["maxDataPoints"] = this.maxDataPoints;
        return data;
    }
}

export interface IConfiguredMetricDto {
    id: string;
    calculationVariableName: string;
    name: string;
    unitsOfMeasure: UnitsOfMeasureDto;
    dataSummary: DataSummaryDto;
    inputDataDefinitionId: IMetricDto;
    timeStep: TimeStep;
    aggregate: Aggregation;
    isIncludedInOutputChannels: boolean;
    maxDataPoints: number;
}

export class UnitsOfMeasureDto implements IUnitsOfMeasureDto {
    id!: number;
    displayName!: string;
    valueFormatString!: string;
    decimalPlaces!: number | undefined;

    constructor(data?: IUnitsOfMeasureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.valueFormatString = _data["valueFormatString"];
            this.decimalPlaces = _data["decimalPlaces"];
        }
    }

    static fromJS(data: any): UnitsOfMeasureDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitsOfMeasureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["valueFormatString"] = this.valueFormatString;
        data["decimalPlaces"] = this.decimalPlaces;
        return data;
    }
}

export interface IUnitsOfMeasureDto {
    id: number;
    displayName: string;
    valueFormatString: string;
    decimalPlaces: number | undefined;
}

export class DataSummaryDto implements IDataSummaryDto {
    period!: moment.Duration | undefined;

    constructor(data?: IDataSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"] ? moment.duration(_data["period"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DataSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period ? this.period.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        return data;
    }
}

export interface IDataSummaryDto {
    period: moment.Duration | undefined;
}

export enum TimeStep {
    Raw = "Raw",
    HalfHour = "HalfHour",
    Hour = "Hour",
    Day = "Day",
    Week = "Week",
    Month = "Month",
    Quarter = "Quarter",
    Yearly = "Yearly",
    EntireRange = "EntireRange",
}

export enum Aggregation {
    None = "None",
    Average = "Average",
    Minimum = "Minimum",
    Maximum = "Maximum",
    Sum = "Sum",
    Count = "Count",
}

export class ChannelContainerDto implements IChannelContainerDto {
    type!: OutputChannelTypeId;
    state!: any | undefined;

    constructor(data?: IChannelContainerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): ChannelContainerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelContainerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["state"] = this.state;
        return data;
    }
}

export interface IChannelContainerDto {
    type: OutputChannelTypeId;
    state: any | undefined;
}

export enum OutputChannelTypeId {
    CHART = "CHART",
    TABLE = "TABLE",
    FILE = "FILE",
    API = "API",
    NEW = "NEW",
}

export class TrendLinksDto implements ITrendLinksDto {
    show!: ResourceActionDto | undefined;
    artifact!: ResourceActionDto | undefined;
    embeddableArtifact!: ResourceActionDto | undefined;

    constructor(data?: ITrendLinksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.show = _data["show"] ? ResourceActionDto.fromJS(_data["show"]) : <any>undefined;
            this.artifact = _data["artifact"] ? ResourceActionDto.fromJS(_data["artifact"]) : <any>undefined;
            this.embeddableArtifact = _data["embeddableArtifact"] ? ResourceActionDto.fromJS(_data["embeddableArtifact"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TrendLinksDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrendLinksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["show"] = this.show ? this.show.toJSON() : <any>undefined;
        data["artifact"] = this.artifact ? this.artifact.toJSON() : <any>undefined;
        data["embeddableArtifact"] = this.embeddableArtifact ? this.embeddableArtifact.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITrendLinksDto {
    show: ResourceActionDto | undefined;
    artifact: ResourceActionDto | undefined;
    embeddableArtifact: ResourceActionDto | undefined;
}

export class ResourceActionDto implements IResourceActionDto {
    method!: string | undefined;
    resourceUri!: string | undefined;

    constructor(data?: IResourceActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.method = _data["method"];
            this.resourceUri = _data["resourceUri"];
        }
    }

    static fromJS(data: any): ResourceActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method;
        data["resourceUri"] = this.resourceUri;
        return data;
    }
}

export interface IResourceActionDto {
    method: string | undefined;
    resourceUri: string | undefined;
}

export class TrendApiLinksDto implements ITrendApiLinksDto {
    get!: ResourceActionDto | undefined;
    update!: ResourceActionDto | undefined;
    publish!: ResourceActionDto | undefined;
    delete!: ResourceActionDto | undefined;

    constructor(data?: ITrendApiLinksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.get = _data["get"] ? ResourceActionDto.fromJS(_data["get"]) : <any>undefined;
            this.update = _data["update"] ? ResourceActionDto.fromJS(_data["update"]) : <any>undefined;
            this.publish = _data["publish"] ? ResourceActionDto.fromJS(_data["publish"]) : <any>undefined;
            this.delete = _data["delete"] ? ResourceActionDto.fromJS(_data["delete"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TrendApiLinksDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrendApiLinksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["get"] = this.get ? this.get.toJSON() : <any>undefined;
        data["update"] = this.update ? this.update.toJSON() : <any>undefined;
        data["publish"] = this.publish ? this.publish.toJSON() : <any>undefined;
        data["delete"] = this.delete ? this.delete.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITrendApiLinksDto {
    get: ResourceActionDto | undefined;
    update: ResourceActionDto | undefined;
    publish: ResourceActionDto | undefined;
    delete: ResourceActionDto | undefined;
}

export class ArtifactEntryPointArgs implements IArtifactEntryPointArgs {
    product!: ProductDto | undefined;
    trendResource!: TrendResourceDto | undefined;
    apiVersion!: string | undefined;

    constructor(data?: IArtifactEntryPointArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            this.trendResource = _data["trendResource"] ? TrendResourceDto.fromJS(_data["trendResource"]) : <any>undefined;
            this.apiVersion = _data["apiVersion"];
        }
    }

    static fromJS(data: any): ArtifactEntryPointArgs {
        data = typeof data === 'object' ? data : {};
        let result = new ArtifactEntryPointArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["trendResource"] = this.trendResource ? this.trendResource.toJSON() : <any>undefined;
        data["apiVersion"] = this.apiVersion;
        return data;
    }
}

export interface IArtifactEntryPointArgs {
    product: ProductDto | undefined;
    trendResource: TrendResourceDto | undefined;
    apiVersion: string | undefined;
}

export class EmbeddableArtifactEntryPointArgs implements IEmbeddableArtifactEntryPointArgs {
    apiVersion!: string | undefined;
    product!: ProductDto | undefined;
    embedBaseUrl!: string | undefined;
    trendResource!: TrendResourceDto | undefined;
    container!: EmbeddableArtifactContainerArgs | undefined;

    constructor(data?: IEmbeddableArtifactEntryPointArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiVersion = _data["apiVersion"];
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            this.embedBaseUrl = _data["embedBaseUrl"];
            this.trendResource = _data["trendResource"] ? TrendResourceDto.fromJS(_data["trendResource"]) : <any>undefined;
            this.container = _data["container"] ? EmbeddableArtifactContainerArgs.fromJS(_data["container"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmbeddableArtifactEntryPointArgs {
        data = typeof data === 'object' ? data : {};
        let result = new EmbeddableArtifactEntryPointArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiVersion"] = this.apiVersion;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["embedBaseUrl"] = this.embedBaseUrl;
        data["trendResource"] = this.trendResource ? this.trendResource.toJSON() : <any>undefined;
        data["container"] = this.container ? this.container.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmbeddableArtifactEntryPointArgs {
    apiVersion: string | undefined;
    product: ProductDto | undefined;
    embedBaseUrl: string | undefined;
    trendResource: TrendResourceDto | undefined;
    container: EmbeddableArtifactContainerArgs | undefined;
}

export class EmbeddableArtifactContainerArgs implements IEmbeddableArtifactContainerArgs {
    widgetLogo!: ImageDefinition | undefined;
    sponsorLogo!: ImageDefinition | undefined;
    twitterMessage!: string | undefined;
    twitterAccountId!: string | undefined;
    socialBaseUrl!: string | undefined;

    constructor(data?: IEmbeddableArtifactContainerArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetLogo = _data["widgetLogo"] ? ImageDefinition.fromJS(_data["widgetLogo"]) : <any>undefined;
            this.sponsorLogo = _data["sponsorLogo"] ? ImageDefinition.fromJS(_data["sponsorLogo"]) : <any>undefined;
            this.twitterMessage = _data["twitterMessage"];
            this.twitterAccountId = _data["twitterAccountId"];
            this.socialBaseUrl = _data["socialBaseUrl"];
        }
    }

    static fromJS(data: any): EmbeddableArtifactContainerArgs {
        data = typeof data === 'object' ? data : {};
        let result = new EmbeddableArtifactContainerArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetLogo"] = this.widgetLogo ? this.widgetLogo.toJSON() : <any>undefined;
        data["sponsorLogo"] = this.sponsorLogo ? this.sponsorLogo.toJSON() : <any>undefined;
        data["twitterMessage"] = this.twitterMessage;
        data["twitterAccountId"] = this.twitterAccountId;
        data["socialBaseUrl"] = this.socialBaseUrl;
        return data;
    }
}

export interface IEmbeddableArtifactContainerArgs {
    widgetLogo: ImageDefinition | undefined;
    sponsorLogo: ImageDefinition | undefined;
    twitterMessage: string | undefined;
    twitterAccountId: string | undefined;
    socialBaseUrl: string | undefined;
}

export class ImageDefinition implements IImageDefinition {
    linkUrl!: string | undefined;
    imageUrl!: string | undefined;
    tooltip!: string | undefined;

    constructor(data?: IImageDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkUrl = _data["linkUrl"];
            this.imageUrl = _data["imageUrl"];
            this.tooltip = _data["tooltip"];
        }
    }

    static fromJS(data: any): ImageDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new ImageDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkUrl"] = this.linkUrl;
        data["imageUrl"] = this.imageUrl;
        data["tooltip"] = this.tooltip;
        return data;
    }
}

export interface IImageDefinition {
    linkUrl: string | undefined;
    imageUrl: string | undefined;
    tooltip: string | undefined;
}

export enum FeatureToggle {
    None = "None",
}

export class FeatureToggleSummary implements IFeatureToggleSummary {
    id!: FeatureToggle;
    name!: string;
    isOn!: boolean;
    isOnForMe!: boolean;
    isOnForEveryone!: boolean;
    isOnForPeople!: string[] | undefined;

    constructor(data?: IFeatureToggleSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isOn = _data["isOn"];
            this.isOnForMe = _data["isOnForMe"];
            this.isOnForEveryone = _data["isOnForEveryone"];
            if (Array.isArray(_data["isOnForPeople"])) {
                this.isOnForPeople = [] as any;
                for (let item of _data["isOnForPeople"])
                    this.isOnForPeople!.push(item);
            }
        }
    }

    static fromJS(data: any): FeatureToggleSummary {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureToggleSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isOn"] = this.isOn;
        data["isOnForMe"] = this.isOnForMe;
        data["isOnForEveryone"] = this.isOnForEveryone;
        if (Array.isArray(this.isOnForPeople)) {
            data["isOnForPeople"] = [];
            for (let item of this.isOnForPeople)
                data["isOnForPeople"].push(item);
        }
        return data;
    }
}

export interface IFeatureToggleSummary {
    id: FeatureToggle;
    name: string;
    isOn: boolean;
    isOnForMe: boolean;
    isOnForEveryone: boolean;
    isOnForPeople: string[] | undefined;
}

export class SearchResultDto implements ISearchResultDto {
    resultCount!: number;
    selectedTab!: TabDto;
    tabs!: TabSummaryDto[];

    constructor(data?: ISearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.selectedTab = _data["selectedTab"] ? TabDto.fromJS(_data["selectedTab"]) : <any>undefined;
            if (Array.isArray(_data["tabs"])) {
                this.tabs = [] as any;
                for (let item of _data["tabs"])
                    this.tabs!.push(TabSummaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["selectedTab"] = this.selectedTab ? this.selectedTab.toJSON() : <any>undefined;
        if (Array.isArray(this.tabs)) {
            data["tabs"] = [];
            for (let item of this.tabs)
                data["tabs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchResultDto {
    resultCount: number;
    selectedTab: TabDto;
    tabs: TabSummaryDto[];
}

export class TabDto implements ITabDto {
    id!: string;
    name!: string;
    columns!: ColumnDto[];
    rows!: RowDto[];
    availableGroupingFacets!: FacetKeyDto[];
    selectedGroupingFacets!: FacetKeyDto[];

    constructor(data?: ITabDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(ColumnDto.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(RowDto.fromJS(item));
            }
            if (Array.isArray(_data["availableGroupingFacets"])) {
                this.availableGroupingFacets = [] as any;
                for (let item of _data["availableGroupingFacets"])
                    this.availableGroupingFacets!.push(FacetKeyDto.fromJS(item));
            }
            if (Array.isArray(_data["selectedGroupingFacets"])) {
                this.selectedGroupingFacets = [] as any;
                for (let item of _data["selectedGroupingFacets"])
                    this.selectedGroupingFacets!.push(FacetKeyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TabDto {
        data = typeof data === 'object' ? data : {};
        let result = new TabDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        if (Array.isArray(this.availableGroupingFacets)) {
            data["availableGroupingFacets"] = [];
            for (let item of this.availableGroupingFacets)
                data["availableGroupingFacets"].push(item.toJSON());
        }
        if (Array.isArray(this.selectedGroupingFacets)) {
            data["selectedGroupingFacets"] = [];
            for (let item of this.selectedGroupingFacets)
                data["selectedGroupingFacets"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITabDto {
    id: string;
    name: string;
    columns: ColumnDto[];
    rows: RowDto[];
    availableGroupingFacets: FacetKeyDto[];
    selectedGroupingFacets: FacetKeyDto[];
}

export class ColumnDto implements IColumnDto {
    index!: number;
    name!: string;
    tooltipInfo!: TooltipInfoDto;

    constructor(data?: IColumnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.name = _data["name"];
            this.tooltipInfo = _data["tooltipInfo"] ? TooltipInfoDto.fromJS(_data["tooltipInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ColumnDto {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["name"] = this.name;
        data["tooltipInfo"] = this.tooltipInfo ? this.tooltipInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IColumnDto {
    index: number;
    name: string;
    tooltipInfo: TooltipInfoDto;
}

export class TooltipInfoDto implements ITooltipInfoDto {
    displayName!: string;
    tooltip!: string;
    unitsOfMeasure!: string;
    cadence!: string;

    constructor(data?: ITooltipInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.tooltip = _data["tooltip"];
            this.unitsOfMeasure = _data["unitsOfMeasure"];
            this.cadence = _data["cadence"];
        }
    }

    static fromJS(data: any): TooltipInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TooltipInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["tooltip"] = this.tooltip;
        data["unitsOfMeasure"] = this.unitsOfMeasure;
        data["cadence"] = this.cadence;
        return data;
    }
}

export interface ITooltipInfoDto {
    displayName: string;
    tooltip: string;
    unitsOfMeasure: string;
    cadence: string;
}

export class RowDto implements IRowDto {
    name!: string;
    cells!: CellDto[];
    children!: RowDto[];

    constructor(data?: IRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["cells"])) {
                this.cells = [] as any;
                for (let item of _data["cells"])
                    this.cells!.push(CellDto.fromJS(item));
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(RowDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RowDto {
        data = typeof data === 'object' ? data : {};
        let result = new RowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.cells)) {
            data["cells"] = [];
            for (let item of this.cells)
                data["cells"].push(item.toJSON());
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRowDto {
    name: string;
    cells: CellDto[];
    children: RowDto[];
}

export class CellDto implements ICellDto {
    columnIndex!: number;
    score!: number;
    metric!: IMetricDto;

    constructor(data?: ICellDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columnIndex = _data["columnIndex"];
            this.score = _data["score"];
            this.metric = _data["metric"] ? IMetricDto.fromJS(_data["metric"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CellDto {
        data = typeof data === 'object' ? data : {};
        let result = new CellDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnIndex"] = this.columnIndex;
        data["score"] = this.score;
        data["metric"] = this.metric ? this.metric.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICellDto {
    columnIndex: number;
    score: number;
    metric: IMetricDto;
}

export class FacetKeyDto implements IFacetKeyDto {
    id!: string;
    name!: string;

    constructor(data?: IFacetKeyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FacetKeyDto {
        data = typeof data === 'object' ? data : {};
        let result = new FacetKeyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IFacetKeyDto {
    id: string;
    name: string;
}

export class TabSummaryDto implements ITabSummaryDto {
    id!: string;
    name!: string;

    constructor(data?: ITabSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TabSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TabSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITabSummaryDto {
    id: string;
    name: string;
}

export class InputDataDefinitionDto implements IInputDataDefinitionDto {
    id!: IMetricDto | undefined;
    name!: string | undefined;

    constructor(data?: IInputDataDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] ? IMetricDto.fromJS(_data["id"]) : <any>undefined;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): InputDataDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputDataDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["name"] = this.name;
        return data;
    }
}

export interface IInputDataDefinitionDto {
    id: IMetricDto | undefined;
    name: string | undefined;
}

export class MetricChildrenRequestDto implements IMetricChildrenRequestDto {
    aggregatedMetrics!: IMetricDto[] | undefined;
    groupingFacets!: SelectedFacet[] | undefined;

    constructor(data?: IMetricChildrenRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["aggregatedMetrics"])) {
                this.aggregatedMetrics = [] as any;
                for (let item of _data["aggregatedMetrics"])
                    this.aggregatedMetrics!.push(IMetricDto.fromJS(item));
            }
            if (Array.isArray(_data["groupingFacets"])) {
                this.groupingFacets = [] as any;
                for (let item of _data["groupingFacets"])
                    this.groupingFacets!.push(SelectedFacet.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MetricChildrenRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetricChildrenRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.aggregatedMetrics)) {
            data["aggregatedMetrics"] = [];
            for (let item of this.aggregatedMetrics)
                data["aggregatedMetrics"].push(item.toJSON());
        }
        if (Array.isArray(this.groupingFacets)) {
            data["groupingFacets"] = [];
            for (let item of this.groupingFacets)
                data["groupingFacets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMetricChildrenRequestDto {
    aggregatedMetrics: IMetricDto[] | undefined;
    groupingFacets: SelectedFacet[] | undefined;
}

export class SelectedFacet implements ISelectedFacet {
    id!: string | undefined;

    constructor(data?: ISelectedFacet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SelectedFacet {
        data = typeof data === 'object' ? data : {};
        let result = new SelectedFacet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ISelectedFacet {
    id: string | undefined;
}

export class Organisation implements IOrganisation {
    id!: string;
    name!: string;
    emailDomainObjects!: EmailDomain[];
    emailDomains!: string[];

    constructor(data?: IOrganisation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["emailDomainObjects"])) {
                this.emailDomainObjects = [] as any;
                for (let item of _data["emailDomainObjects"])
                    this.emailDomainObjects!.push(EmailDomain.fromJS(item));
            }
            if (Array.isArray(_data["emailDomains"])) {
                this.emailDomains = [] as any;
                for (let item of _data["emailDomains"])
                    this.emailDomains!.push(item);
            }
        }
    }

    static fromJS(data: any): Organisation {
        data = typeof data === 'object' ? data : {};
        let result = new Organisation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.emailDomainObjects)) {
            data["emailDomainObjects"] = [];
            for (let item of this.emailDomainObjects)
                data["emailDomainObjects"].push(item.toJSON());
        }
        if (Array.isArray(this.emailDomains)) {
            data["emailDomains"] = [];
            for (let item of this.emailDomains)
                data["emailDomains"].push(item);
        }
        return data;
    }
}

export interface IOrganisation {
    id: string;
    name: string;
    emailDomainObjects: EmailDomain[];
    emailDomains: string[];
}

export class EmailDomain implements IEmailDomain {
    domain!: string;
    isDeprecated!: boolean;

    constructor(data?: IEmailDomain) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domain = _data["domain"];
            this.isDeprecated = _data["isDeprecated"];
        }
    }

    static fromJS(data: any): EmailDomain {
        data = typeof data === 'object' ? data : {};
        let result = new EmailDomain();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domain"] = this.domain;
        data["isDeprecated"] = this.isDeprecated;
        return data;
    }
}

export interface IEmailDomain {
    domain: string;
    isDeprecated: boolean;
}

export class TemplateSummaryDto implements ITemplateSummaryDto {
    id!: string;
    name!: string;

    constructor(data?: ITemplateSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TemplateSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITemplateSummaryDto {
    id: string;
    name: string;
}

export class TrendSummaryResourceDto implements ITrendSummaryResourceDto {
    trendSummary!: TrendSummaryDto;
    links!: TrendSummaryLinksDto;

    constructor(data?: ITrendSummaryResourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.trendSummary = new TrendSummaryDto();
            this.links = new TrendSummaryLinksDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trendSummary = _data["trendSummary"] ? TrendSummaryDto.fromJS(_data["trendSummary"]) : new TrendSummaryDto();
            this.links = _data["links"] ? TrendSummaryLinksDto.fromJS(_data["links"]) : new TrendSummaryLinksDto();
        }
    }

    static fromJS(data: any): TrendSummaryResourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrendSummaryResourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trendSummary"] = this.trendSummary ? this.trendSummary.toJSON() : <any>undefined;
        data["links"] = this.links ? this.links.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITrendSummaryResourceDto {
    trendSummary: TrendSummaryDto;
    links: TrendSummaryLinksDto;
}

export class TrendSummaryDto implements ITrendSummaryDto {
    id!: string | undefined;
    title!: string | undefined;
    isDraft!: boolean;
    isPublished!: boolean;
    userId!: string | undefined;
    creationTime!: moment.Moment;
    lastSavedTime!: moment.Moment;
    ownerIsAGrId!: boolean;

    constructor(data?: ITrendSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.isDraft = _data["isDraft"];
            this.isPublished = _data["isPublished"];
            this.userId = _data["userId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastSavedTime = _data["lastSavedTime"] ? moment(_data["lastSavedTime"].toString()) : <any>undefined;
            this.ownerIsAGrId = _data["ownerIsAGrId"];
        }
    }

    static fromJS(data: any): TrendSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrendSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["isDraft"] = this.isDraft;
        data["isPublished"] = this.isPublished;
        data["userId"] = this.userId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastSavedTime"] = this.lastSavedTime ? this.lastSavedTime.toISOString() : <any>undefined;
        data["ownerIsAGrId"] = this.ownerIsAGrId;
        return data;
    }
}

export interface ITrendSummaryDto {
    id: string | undefined;
    title: string | undefined;
    isDraft: boolean;
    isPublished: boolean;
    userId: string | undefined;
    creationTime: moment.Moment;
    lastSavedTime: moment.Moment;
    ownerIsAGrId: boolean;
}

export class TrendSummaryLinksDto implements ITrendSummaryLinksDto {
    show!: ResourceActionDto;

    constructor(data?: ITrendSummaryLinksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.show = new ResourceActionDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.show = _data["show"] ? ResourceActionDto.fromJS(_data["show"]) : new ResourceActionDto();
        }
    }

    static fromJS(data: any): TrendSummaryLinksDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrendSummaryLinksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["show"] = this.show ? this.show.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITrendSummaryLinksDto {
    show: ResourceActionDto;
}

export class TrendDescriptionDto implements ITrendDescriptionDto {
    text!: string | undefined;
    html!: string | undefined;

    constructor(data?: ITrendDescriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.html = _data["html"];
        }
    }

    static fromJS(data: any): TrendDescriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrendDescriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["html"] = this.html;
        return data;
    }
}

export interface ITrendDescriptionDto {
    text: string | undefined;
    html: string | undefined;
}

export class TrendPutResult implements ITrendPutResult {
    _etag!: string | undefined;

    constructor(data?: ITrendPutResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._etag = _data["_etag"];
        }
    }

    static fromJS(data: any): TrendPutResult {
        data = typeof data === 'object' ? data : {};
        let result = new TrendPutResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_etag"] = this._etag;
        return data;
    }
}

export interface ITrendPutResult {
    _etag: string | undefined;
}

export class TrendPublishDto implements ITrendPublishDto {
    id!: string | undefined;
    title!: string | undefined;
    publishedToOrganisations!: string[] | undefined;

    constructor(data?: ITrendPublishDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            if (Array.isArray(_data["publishedToOrganisations"])) {
                this.publishedToOrganisations = [] as any;
                for (let item of _data["publishedToOrganisations"])
                    this.publishedToOrganisations!.push(item);
            }
        }
    }

    static fromJS(data: any): TrendPublishDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrendPublishDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        if (Array.isArray(this.publishedToOrganisations)) {
            data["publishedToOrganisations"] = [];
            for (let item of this.publishedToOrganisations)
                data["publishedToOrganisations"].push(item);
        }
        return data;
    }
}

export interface ITrendPublishDto {
    id: string | undefined;
    title: string | undefined;
    publishedToOrganisations: string[] | undefined;
}

export class JavaScriptClientDto implements IJavaScriptClientDto {
    authority!: string;
    clientId!: string;
    redirectUrl!: string;
    silentRedirectUrl!: string;
    responseType!: string;
    scope!: string;
    postLogoutRedirectUrl!: string;

    constructor(data?: IJavaScriptClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authority = _data["authority"];
            this.clientId = _data["clientId"];
            this.redirectUrl = _data["redirectUrl"];
            this.silentRedirectUrl = _data["silentRedirectUrl"];
            this.responseType = _data["responseType"];
            this.scope = _data["scope"];
            this.postLogoutRedirectUrl = _data["postLogoutRedirectUrl"];
        }
    }

    static fromJS(data: any): JavaScriptClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new JavaScriptClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authority"] = this.authority;
        data["clientId"] = this.clientId;
        data["redirectUrl"] = this.redirectUrl;
        data["silentRedirectUrl"] = this.silentRedirectUrl;
        data["responseType"] = this.responseType;
        data["scope"] = this.scope;
        data["postLogoutRedirectUrl"] = this.postLogoutRedirectUrl;
        return data;
    }
}

export interface IJavaScriptClientDto {
    authority: string;
    clientId: string;
    redirectUrl: string;
    silentRedirectUrl: string;
    responseType: string;
    scope: string;
    postLogoutRedirectUrl: string;
}

export class IsAuthorisedDto implements IIsAuthorisedDto {
    isAuthorised!: boolean;

    constructor(data?: IIsAuthorisedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAuthorised = _data["isAuthorised"];
        }
    }

    static fromJS(data: any): IsAuthorisedDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsAuthorisedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthorised"] = this.isAuthorised;
        return data;
    }
}

export interface IIsAuthorisedDto {
    isAuthorised: boolean;
}

export class TrendsMetricApiResponse implements ITrendsMetricApiResponse {
    configuredMetric!: ConfiguredMetricDto;
    available!: string[];
    pending!: string[];
    pendingRealtime!: string[];
    isForecast!: boolean;

    constructor(data?: ITrendsMetricApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.configuredMetric = new ConfiguredMetricDto();
            this.available = [];
            this.pending = [];
            this.pendingRealtime = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configuredMetric = _data["configuredMetric"] ? ConfiguredMetricDto.fromJS(_data["configuredMetric"]) : new ConfiguredMetricDto();
            if (Array.isArray(_data["available"])) {
                this.available = [] as any;
                for (let item of _data["available"])
                    this.available!.push(item);
            }
            if (Array.isArray(_data["pending"])) {
                this.pending = [] as any;
                for (let item of _data["pending"])
                    this.pending!.push(item);
            }
            if (Array.isArray(_data["pendingRealtime"])) {
                this.pendingRealtime = [] as any;
                for (let item of _data["pendingRealtime"])
                    this.pendingRealtime!.push(item);
            }
            this.isForecast = _data["isForecast"];
        }
    }

    static fromJS(data: any): TrendsMetricApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TrendsMetricApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configuredMetric"] = this.configuredMetric ? this.configuredMetric.toJSON() : <any>undefined;
        if (Array.isArray(this.available)) {
            data["available"] = [];
            for (let item of this.available)
                data["available"].push(item);
        }
        if (Array.isArray(this.pending)) {
            data["pending"] = [];
            for (let item of this.pending)
                data["pending"].push(item);
        }
        if (Array.isArray(this.pendingRealtime)) {
            data["pendingRealtime"] = [];
            for (let item of this.pendingRealtime)
                data["pendingRealtime"].push(item);
        }
        data["isForecast"] = this.isForecast;
        return data;
    }
}

export interface ITrendsMetricApiResponse {
    configuredMetric: ConfiguredMetricDto;
    available: string[];
    pending: string[];
    pendingRealtime: string[];
    isForecast: boolean;
}

export class SeriesDataCollectionRequestDto implements ISeriesDataCollectionRequestDto {
    start!: moment.Moment;
    end!: moment.Moment;
    pointInTimeContext!: moment.Moment;
    configuredDataDefinitions!: ConfiguredMetricDto[] | undefined;
    utcOffsetInMinutes!: number;
    requestId!: string | undefined;

    constructor(data?: ISeriesDataCollectionRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? moment(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? moment(_data["end"].toString()) : <any>undefined;
            this.pointInTimeContext = _data["pointInTimeContext"] ? moment(_data["pointInTimeContext"].toString()) : <any>undefined;
            if (Array.isArray(_data["configuredDataDefinitions"])) {
                this.configuredDataDefinitions = [] as any;
                for (let item of _data["configuredDataDefinitions"])
                    this.configuredDataDefinitions!.push(ConfiguredMetricDto.fromJS(item));
            }
            this.utcOffsetInMinutes = _data["utcOffsetInMinutes"];
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): SeriesDataCollectionRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeriesDataCollectionRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["pointInTimeContext"] = this.pointInTimeContext ? this.pointInTimeContext.toISOString() : <any>undefined;
        if (Array.isArray(this.configuredDataDefinitions)) {
            data["configuredDataDefinitions"] = [];
            for (let item of this.configuredDataDefinitions)
                data["configuredDataDefinitions"].push(item.toJSON());
        }
        data["utcOffsetInMinutes"] = this.utcOffsetInMinutes;
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface ISeriesDataCollectionRequestDto {
    start: moment.Moment;
    end: moment.Moment;
    pointInTimeContext: moment.Moment;
    configuredDataDefinitions: ConfiguredMetricDto[] | undefined;
    utcOffsetInMinutes: number;
    requestId: string | undefined;
}

export class DataPointDto implements IDataPointDto {
    timeStamp!: moment.Moment;
    value!: number;

    constructor(data?: IDataPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeStamp = _data["timeStamp"] ? moment(_data["timeStamp"].toString()) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DataPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface IDataPointDto {
    timeStamp: moment.Moment;
    value: number;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

/* eslint-disable @typescript-eslint/no-explicit-any */

// input data definition id implementations (to get around the generated code not being able to construct interfaces)

export interface IIMetricDto {
  type: string;
}

export class IMetricDto implements IIMetricDto {
  type!: string;

  constructor(data?: IMetricDto) {
    if (data) {
      for (const property in data) {
        if (Object.prototype.hasOwnProperty.call(data, property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(): void {
    throw new Error('init called on IMetricDto');
  }

  static fromJS(data: any): IMetricDto {
    switch (data['type']) {
      case 'Raw':
        return RawMetricDto.fromJS(data);
      case 'Aggregate':
        return AggregateMetricDto.fromJS(data);
      case 'Calculated':
        return CalculatedMetricDto.fromJS(data);
      default:
        throw new Error(`${data['type']} could not be created.`);
    }
  }

  toJSON(): void {
    throw new Error('toJSON called on IMetricDto');
  }
}

export class RawMetricDto implements ISearchResultMetricDto {
  type = 'Raw';
  id!: string;
  tooltipInfo: TooltipInfoDto | undefined;

  init(_data?: any): void {
    if (_data) {
      this.type = _data['type'];
      this.id = _data['id'];
      this.tooltipInfo = _data['tooltipInfo'] ? TooltipInfoDto.fromJS(_data['tooltipInfo']) : <any>undefined;
    }
  }

  static fromJS(data: any): RawMetricDto {
    data = typeof data === 'object' ? data : {};
    const result = new RawMetricDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any): any {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    data['id'] = this.id;
    data['tooltipInfo'] = this.tooltipInfo ? this.tooltipInfo.toJSON() : <any>undefined;
    return data;
  }
}

export class AggregateMetricDto implements ISearchResultMetricDto {
  type = 'Aggregate';
  entityTypeId!: string;
  propertyId!: string;
  facets!: { facetId: string; valueId: string }[];
  nonsensical: boolean | undefined;
  tooltipInfo: TooltipInfoDto | undefined;

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
      this.entityTypeId = _data['entityTypeId'];
      this.propertyId = _data['propertyId'];
      if (_data['facets'] && _data['facets'].constructor === Array) {
        this.facets = [];
        for (const item of _data['facets']) this.facets.push({ facetId: item['facetId'], valueId: item['valueId'] });
      }
      this.nonsensical = _data['nonsensical'];
      this.tooltipInfo = _data['tooltipInfo'] ? TooltipInfoDto.fromJS(_data['tooltipInfo']) : <any>undefined;
    }
  }

  static fromJS(data: any): AggregateMetricDto {
    data = typeof data === 'object' ? data : {};
    const result = new AggregateMetricDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    data['entityTypeId'] = this.entityTypeId;
    data['propertyId'] = this.propertyId;

    if (this.facets && this.facets.constructor === Array) {
      data['facets'] = [];
      for (const item of this.facets) data['facets'].push({ facetId: item.facetId, valueId: item.valueId });
    }

    data['nonsensical'] = this.nonsensical;
    data['tooltipInfo'] = this.tooltipInfo ? this.tooltipInfo.toJSON() : <any>undefined;
    return data;
  }
}

export class CalculatedMetricDto extends IMetricDto {
  type = 'Calculated';
  expression!: string;

  init(data?: any) {
    if (data) {
      this.type = data['type'];
      this.expression = data['expression'];
    }
  }

  static fromJS(data: any): CalculatedMetricDto {
    data = typeof data === 'object' ? data : {};
    const result = new CalculatedMetricDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    data['expression'] = this.expression;
    return data;
  }
}

export interface IISearchResultMetricDto extends IIMetricDto {
  tooltipInfo: TooltipInfoDto | undefined;
}

export abstract class ISearchResultMetricDto implements IISearchResultMetricDto {
  type!: string;
  tooltipInfo: TooltipInfoDto | undefined;

  constructor(data?: IISearchResultMetricDto) {
    if (data) {
      for (const property in data) {
        // eslint-disable-next-line no-prototype-builtins
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tooltipInfo = _data['tooltipInfo'] ? TooltipInfoDto.fromJS(_data['tooltipInfo']) : <any>undefined;
    }
  }

  static fromJS(): ISearchResultMetricDto {
    throw new Error("The abstract class 'ISearchResultMetricDto' cannot be instantiated.");
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['tooltipInfo'] = this.tooltipInfo ? this.tooltipInfo.toJSON() : <any>undefined;
    return data;
  }
}